/**
 * Created by lihanying on 2017/7/7.
 */
import React from 'react'
import './style.css'
const ClubInfo = props => {
  return (
    <div style={{ paddingLeft: '1rem' }}>
      <div className="club-info">
        <h3>负责人:</h3>
        <p style={{ paddingLeft: '3rem' }}>{props.official_person}</p>
      </div>
      <div className="club-info">
        <h3>账号:</h3>
        <p style={{ paddingLeft: '3.8rem' }}>{props.account}</p>
      </div>
      <div className="club-info">
        <h3>联系电话:</h3>
        <p style={{ paddingLeft: '2rem' }}>{props.contact_number}</p>
      </div>
      <div className="club-info">
        <h3>手机号码:</h3>
        <p style={{ paddingLeft: '2rem' }}>{props.official_person_phone}</p>
      </div>
      <div className="club-info">
        <h3>俱乐部名:</h3>
        <p style={{ paddingLeft: '2rem' }}>{props.club_name}</p>
      </div>
      <div className="club-info">
        <h3>详细地址:</h3>
        <p style={{ paddingLeft: '2rem' }}>{props.club_address}</p>
      </div>
      <div className="club-info">
        <h3>起始时间:</h3>
        <p style={{ paddingLeft: '2rem' }}>{props.ctime}</p>
      </div>
      <div className="club-info">
        <h3>更新时间:</h3>
        <p style={{ paddingLeft: '2rem' }}>{props.update_time}</p>
      </div>
    </div>
  )
}
export default ClubInfo


// WEBPACK FOOTER //
// ./src/containers/ClubList/component/clubInfo.js